module.exports = __webpack_public_path__ + "static/media/playButtonBackground.9240abe9.png";